import { ImageUploadModel } from '@components/file';
import { showError } from '@lib/utils';
import { authService } from '@services/auth.service';
import {
  Button, DatePicker, Form, Input, Select, message, Checkbox
} from 'antd';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useRef, useState } from 'react';
import {
  connect, ConnectedProps, useSelector, useDispatch
} from 'react-redux';
import { COUNTRIES } from 'src/constants/countries';
import dayjs from 'dayjs';
import { IPerformerCategory } from '@interfaces/performer-category';
import { login } from '@redux/auth/authSlice';
import style from './model-register-form.module.scss';

const { Option } = Select;

// Play badge icon
function PlayIcon() {
  return (
    <svg width="46" height="45" viewBox="0 0 46 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.8152 2.33325C34.1029 2.33325 43.2535 11.3175 43.2535 22.3999C43.2535 33.4823 34.1029 42.4666 22.8152 42.4666C21.2524 42.4666 19.7314 42.2948 18.2675 41.9682C18.0848 41.9275 17.9122 41.8519 17.7593 41.7457C17.6064 41.6394 17.4763 41.5047 17.3765 41.3491C17.2767 41.1936 17.209 41.0202 17.1774 40.839C17.1458 40.6577 17.1509 40.4722 17.1923 40.2929C17.2338 40.1135 17.3108 39.944 17.419 39.7939C17.5272 39.6438 17.6644 39.5161 17.8228 39.4181C17.9813 39.3201 18.1578 39.2536 18.3424 39.2226C18.527 39.1916 18.716 39.1966 18.8987 39.2372C21.4737 39.8118 24.1474 39.8097 26.7214 39.231C29.2954 38.6523 31.7036 37.5119 33.7674 35.8945C35.8312 34.2771 37.4975 32.2241 38.6426 29.888C39.7878 27.5519 40.3825 24.9925 40.3825 22.3999C40.3825 19.8073 39.7878 17.248 38.6426 14.9118C37.4975 12.5757 35.8312 10.5227 33.7674 8.90532C31.7036 7.2879 29.2954 6.14754 26.7214 5.56886C24.1474 4.99017 21.4737 4.98803 18.8987 5.56258C18.5298 5.64477 18.1428 5.57972 17.8228 5.38176C17.5028 5.18379 17.276 4.86913 17.1923 4.50698C17.1086 4.14484 17.1749 3.76488 17.3765 3.4507C17.5781 3.13651 17.8986 2.91383 18.2675 2.83165C19.7314 2.50499 21.2524 2.33325 22.8152 2.33325ZM5.95508 31.1471C6.27505 30.9494 6.66187 30.8846 7.03051 30.9669C7.39916 31.0491 7.71944 31.2717 7.92095 31.5858C9.32982 33.782 11.2223 35.6401 13.4593 37.0234C13.6178 37.1214 13.7551 37.2492 13.8634 37.3993C13.9716 37.5495 14.0487 37.7191 14.0902 37.8985C14.1317 38.0779 14.1368 38.2636 14.1052 38.4449C14.0736 38.6263 14.0059 38.7997 13.906 38.9554C13.8062 39.111 13.6761 39.2459 13.5231 39.3522C13.3702 39.4584 13.1974 39.5341 13.0147 39.5748C12.6457 39.6571 12.2585 39.5921 11.9383 39.394C9.34111 37.7874 7.14389 35.6295 5.50829 33.0791C5.4083 32.9235 5.34053 32.75 5.30887 32.5687C5.27721 32.3873 5.28227 32.2016 5.32377 32.0222C5.36527 31.8427 5.44238 31.6731 5.55071 31.523C5.65903 31.3728 5.79644 31.2451 5.95508 31.1471ZM5.66609 18.5546C5.74979 18.1924 5.68354 17.8125 5.48191 17.4983C5.28028 17.1841 4.95979 16.9614 4.59094 16.8792C4.22209 16.7971 3.8351 16.8621 3.51509 17.0601C3.19509 17.258 2.96829 17.5727 2.88458 17.9348C2.55187 19.3722 2.37695 20.8655 2.37695 22.3999C2.37695 23.9343 2.55187 25.4276 2.88458 26.8668C2.96854 27.229 3.19558 27.5436 3.51576 27.7413C3.83595 27.9391 4.22304 28.0039 4.59189 27.9215C4.96074 27.8391 5.28113 27.6162 5.48259 27.3018C5.68404 26.9874 5.75005 26.6074 5.66609 26.2453C5.37484 24.9835 5.22817 23.6937 5.22881 22.3999C5.22881 21.0765 5.3809 19.7903 5.66609 18.5546ZM13.906 5.84632C14.1074 6.16047 14.1734 6.54026 14.0896 6.9022C14.0059 7.26414 13.7791 7.5786 13.4593 7.77645C11.2221 9.16023 9.32959 11.019 7.92095 13.2159C7.71926 13.5303 7.39863 13.7531 7.0296 13.8354C6.66057 13.9176 6.27337 13.8526 5.95318 13.6546C5.63298 13.4566 5.40603 13.1418 5.32224 12.7794C5.23845 12.4171 5.30469 12.037 5.50639 11.7226C7.14308 9.17177 9.34163 7.01383 11.9402 5.40765C12.0987 5.30948 12.2753 5.24295 12.4601 5.21186C12.6448 5.18078 12.8339 5.18575 13.0167 5.22649C13.1994 5.26723 13.3722 5.34294 13.5251 5.4493C13.6781 5.55566 13.8063 5.69057 13.906 5.84632Z" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd" d="M15.6855 17.1975C15.6855 14.5413 18.5298 12.5495 21.0565 14.0149L30.0304 19.2173C32.4506 20.621 32.4506 24.1789 30.0304 25.5826L21.0565 30.7831C18.5298 32.2485 15.6855 30.2567 15.6855 27.6005V17.1975ZM18.9367 16.4359C18.8094 16.5188 18.7058 16.6323 18.6359 16.7656C18.566 16.899 18.5321 17.0477 18.5374 17.1975V27.6005C18.5374 27.9719 18.7199 28.2314 18.9367 28.3639C19.1458 28.4909 19.3777 28.5058 19.6059 28.3733L28.5797 23.1709C28.7112 23.089 28.8187 22.9747 28.8914 22.8395C28.9641 22.7043 28.9995 22.5528 28.9942 22.3999C28.9999 22.2468 28.9646 22.0949 28.8919 21.9593C28.8191 21.8237 28.7115 21.7092 28.5797 21.6271L19.6059 16.4266C19.5054 16.3634 19.3882 16.3305 19.2689 16.3322C19.1496 16.3338 19.0334 16.3699 18.9348 16.4359" fill="white" />
    </svg>

  );
}

const mapStatesToProps = (state: any) => ({ siteName: state.ui.siteName });
const connector = connect(mapStatesToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface P extends PropsFromRedux {
  categories: IPerformerCategory[];
}

function ModelRegisterForm({ siteName, categories }: P) {
  const router = useRouter();
  const dispatch = useDispatch();
  const idFile = useRef<any>(null);
  const [loading, setLoading] = useState(false);
  const { requireEmailVerification = true } = useSelector((state: any) => state.settings);

  const onFileReaded = (file: File, type: string) => {
    if (file && type === 'idFile') idFile.current = file;
  };

  const handleFinish = async (values: any) => {
    try {
      if (!idFile.current) {
        message.error('ID document is required!');
        return;
      }
      setLoading(true);
      await authService.registerPerformer(
        [{ fieldname: 'idVerification', file: idFile.current }],
        values,
        () => {}
      );

      if (!requireEmailVerification) {
        message.success(`Thanks for registering${siteName ? ` at ${siteName}` : ''}! Logging you in...`);
        dispatch(login({ username: values.username, password: values.password, redirect: '/' }));
      } else {
        message.success('Please check your inbox and verify your email address', 10);
        router.push({ pathname: '/auth/login', href: '/' });
      }
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={style['creator-register-page']}>
      <div className={style['creator-register-card']}>

        {/* Badge */}
        <div className={style.badge} aria-hidden="true">
          <PlayIcon />
        </div>

        {/* Title */}
        <h1 className={style.title}>Creator Sign Up</h1>

        <Form
          name="creator_register"
          initialValues={{ gender: 'female', country: 'US', dateOfBirth: '' }}
          onFinish={handleFinish}
          scrollToFirstError
        >
          <div className={style['form-body']}>

            {/* ── Left: field grid ── */}
            <div className={style['fields-grid']}>

              <Form.Item
                name="firstName"
                validateTrigger={['onChange', 'onBlur']}
                rules={[
                  { required: true, message: 'Please input your first name!' },
                  {
                    pattern: /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u,
                    message: 'First name cannot contain numbers or special characters'
                  }
                ]}
              >
                <Input placeholder="First name" maxLength={30} size="large" />
              </Form.Item>

              <Form.Item
                name="lastName"
                validateTrigger={['onChange', 'onBlur']}
                rules={[
                  { required: true, message: 'Please input your last name!' },
                  {
                    pattern: /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u,
                    message: 'Last name cannot contain numbers or special characters'
                  }
                ]}
              >
                <Input placeholder="Last name" maxLength={30} size="large" />
              </Form.Item>

              <Form.Item
                name="name"
                validateTrigger={['onChange', 'onBlur']}
                rules={[
                  { required: true, message: 'Please input your display name!' },
                  { pattern: /^(?=.*\S).+$/g, message: 'Display name cannot be only whitespace' },
                  { min: 3, message: 'Display name must contain at least 3 characters' }
                ]}
              >
                <Input placeholder="Display name" maxLength={30} size="large" />
              </Form.Item>

              <Form.Item
                name="username"
                normalize={(v) => v?.toLowerCase()}
                validateTrigger={['onChange', 'onBlur']}
                rules={[
                  { required: true, message: 'Please input your username!' },
                  { pattern: /^[a-z0-9]+$/g, message: 'Username must contain lowercase alphanumerics only' },
                  { min: 3, message: 'Username must contain at least 3 characters' }
                ]}
              >
                <Input placeholder="Username" maxLength={30} size="large" />
              </Form.Item>

              <Form.Item
                name="email"
                validateTrigger={['onChange', 'onBlur']}
                rules={[
                  { type: 'email', message: 'Invalid email address!' },
                  { required: true, message: 'Please input your email address!' }
                ]}
              >
                <Input placeholder="Email address" size="large" />
              </Form.Item>

              <Form.Item
                name="dateOfBirth"
                validateTrigger={['onChange', 'onBlur']}
                rules={[{ required: true, message: 'Please select your date of birth' }]}
              >
                <DatePicker
                  placeholder="Date of birth (DD/MM/YYYY)"
                  format="DD/MM/YYYY"
                  disabledDate={(d) => d > dayjs().subtract(18, 'year').startOf('day')}
                  size="large"
                  style={{ width: '100%' }}
                />
              </Form.Item>

              <Form.Item name="country" rules={[{ required: true, message: 'Please select your country' }]}>
                <Select showSearch optionFilterProp="label" size="large" style={{ width: '100%' }}>
                  {COUNTRIES.map((c) => (
                    <Option value={c.code} key={c.code} label={c.name}>
                      <img alt={c.name} src={c.flag} width="20" style={{ marginRight: 8 }} />
                      {c.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="gender"
                validateTrigger={['onChange', 'onBlur']}
                rules={[{ required: true, message: 'Please select your gender' }]}
              >
                <Select size="large" style={{ width: '100%' }}>
                  <Option value="male">Male</Option>
                  <Option value="female">Female</Option>
                </Select>
              </Form.Item>

              {categories.length > 0 && (
                <Form.Item
                  name="categoryIds"
                  validateTrigger={['onChange', 'onBlur']}
                  rules={[{ required: true, message: 'Please select your categories' }]}
                  className={style['full-width']}
                >
                  <Select showSearch mode="multiple" placeholder="Select your categories" size="large">
                    {categories.map((s) => (
                      <Select.Option key={s._id} value={s._id}>{s.name}</Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}

              <Form.Item
                name="password"
                validateTrigger={['onChange', 'onBlur']}
                rules={[
                  {
                    pattern: /^(?=.{8,})(?=.*[a-z])(?=.*[0-9])(?=.*[A-Z])(?=.*[^\w\d]).*$/g,
                    message: 'Min 8 chars, 1 number, 1 uppercase, 1 lowercase & 1 special character'
                  },
                  { required: true, message: 'Please enter your password!' }
                ]}
              >
                <Input.Password placeholder="Password" size="large" />
              </Form.Item>

              <Form.Item
                name="confirm"
                dependencies={['password']}
                validateTrigger={['onChange', 'onBlur']}
                rules={[
                  { required: true, message: 'Please confirm your password!' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) return Promise.resolve();
                      return Promise.reject(new Error('Passwords do not match!'));
                    }
                  })
                ]}
              >
                <Input.Password placeholder="Confirm password" size="large" />
              </Form.Item>
            </div>

            {/* ── Right: ID upload ── */}
            <div className={style['id-upload-section']}>
              <div className={style['id-upload-icons']}>
                <ImageUploadModel onFileReaded={(f) => onFileReaded(f, 'idFile')} />
                <img
                  alt="ID document example"
                  src="/front-id.png"
                  className={style['id-preview']}
                />
              </div>
              <p className={style['id-help-text']}>
                Your government issued ID card, National ID card, Passport or Driving license
              </p>
            </div>
          </div>

          {/* Footer: Checkbox + Button */}
          <div className={style['form-footer']} style={{ marginTop: '16px' }}>
            <Form.Item
              name="agreeToTerms"
              valuePropName="checked"
              style={{ margin: 0 }}
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject(new Error('You must agree to the Terms of Service and Privacy Policy'))
                }
              ]}
            >
              <Checkbox>
                <span className={style['terms-text']}>
                  By signing up you agree to our
                  {' '}
                  <Link href="/page/terms-of-service" target="_blank">Terms of Service</Link>
                  {' '}
                  and
                  {' '}
                  <Link href="/page/privacy-policy" target="_blank">Privacy Policy</Link>
                  , and confirm that you are at least 18 years old.
                </span>
              </Checkbox>
            </Form.Item>

            <Form.Item style={{ margin: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                className={style['form-button']}
                disabled={loading}
                loading={loading}
                size="large"
              >
                Create Your Account
              </Button>
            </Form.Item>
          </div>
        </Form>

      </div>
    </div>
  );
}

export default connector(ModelRegisterForm);
